import React, { useEffect } from 'react';
import { updateHeaderColor, updateMobileHeaderColor } from '../../utils/scroll';
import HeaderComponents from '../../components/Header/HeaderComponents';
import SideBannerComponents from '../../components/SideBanner/SideBannerComp';
import { isMobile } from '../../config';

import { overview1, overview2, overview3, overview4, overview5, overview6 } from '../../assets/images/company/companyImages'

import S from './CompanyPage.module.css'

const OverviewPage = () => {
  useEffect(() => {
    window.scrollTo(0, 327);
    
    const wheelHandler = (e) => {
      if(isMobile()) {
        updateMobileHeaderColor();
      } else {
        updateHeaderColor();
      }
    };

    window.addEventListener('scroll', wheelHandler);

    return () => {
      window.removeEventListener('scroll', wheelHandler);
    };
  }, []);

  return (
    <div>
      <HeaderComponents pageKey="company" />
      <div className='sideBannerComp flex-coulum'>
        <div>
          <SideBannerComponents pageKey="company" />
        </div>
        <div className='com-content-wrap mb-50 mt-245' id={S.comContentWrap} style={{minHeight:'650px'}}>
          <div>
            <img src={overview1} />
          </div>
          <div className='mt-100'>
            <img src={overview2} />
          </div>
          <div className='mt-100'>
            <img src={overview3} />
          </div>
          <div className='mt-100'>
            <img src={overview4} />
          </div>
          <div className='mt-100'>
            <img src={overview5} />
          </div>
          <div className='mt-100'>
            <img src={overview6} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverviewPage;
